export default function agree() {

  /* 同意するチェック処理
  ----------------------------------------------------------------- */
  const submitBtn = document.querySelector('input[type="submit"]');
  const checkElm = document.getElementById('js-agree');

  checkElm.onchange = () => {
    if (checkElm.checked) {
      submitBtn.parentNode.classList.add('is-push');
    } else {
      submitBtn.parentNode.classList.remove('is-push');
    }
  }

}